import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
const Spinner: React.FC = () => {
  const spinner = useSelector((state: ApplicationState) => state.spinner);
  if (spinner)
    return (
      <div id="loading">
        <div className="loadingMsg" />
      </div>
    );
  else return <></>;
};

export default React.memo(Spinner);
